module.exports = __webpack_public_path__ + "static/manish-820b60cc9c27ea354da18c0a6ae391c2.jpg";